import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadPopupComponent } from './download-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';
import { CustomInputModule } from "src/app/shared/components/custom-input/custom-input.module";



@NgModule({
  declarations: [
    DownloadPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    CustomInputModule
],
  exports:[
    DownloadPopupComponent
  ]
})
export class DownloadPopupModule { }
